import firebase from "firebase/app";
import "@firebase/storage";
export const storage = firebase.storage();